module.exports = __webpack_public_path__ + "static/img/icon.7c31c6c2.png";